import { CSSProperties } from 'react'
import { CheckBox, Input, InputCard } from '../components';
import { IconVisaMastercard } from '../img'
import { useContext, useEffect, useState } from "react"
import { DataContext } from "../data/DataContext"
import { formatCurrency } from '../../../utils/helpMain'
import Modal from 'react-modal'

const StepPurchaseSummary = () => {
    const { vidaCR, setVidaCR, changeHandler, changeHandler2 } = useContext(DataContext);
    const [isAmex, setIsAmex] = useState(false);
    const [modalTerm, setModalTerm] = useState(false)
    const OnChageString = (property: string, value: string) => {
        setIsAmex(String(vidaCR.cardNumber).substring(0, 2) === '34' || String(vidaCR.cardNumber).substring(0, 2) === '37');
        setVidaCR({ ...vidaCR, [property]: value });
    }


    const rowStyle: CSSProperties = {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '10px'
    }

    const styleModal = {
        overlay: { background: 'rgba(255, 255, 255,0.5)' }
    }


    const GetFullName = () => `${vidaCR.name1} ${vidaCR.name2} ${vidaCR.lastname1} ${vidaCR.lastname2}`
    const GetBeneficiary = () => {
        let name = ""
        if (vidaCR.lstBeneficiary.length > 0) {
            vidaCR?.lstBeneficiary.map(x => {
                if (name.length > 0) name += ', '
                name += `${x.name1} ${x.name2} ${x.lastname1} ${x.lastname2}`
            })
        }

        return name;
    }

    const GetSum = (idco: number) => {
        let detailSelected = vidaCR.lstRateResumen[parseInt(vidaCR.planSelected) - 1]
        if (detailSelected !== undefined)
            return detailSelected?.coveragesDetail.find(x => x.idcob == idco)?.value ?? ''
        return '';
    }

    const GetPrima = () => {
        let detailSelected = vidaCR.lstRateResumen[parseInt(vidaCR.planSelected) - 1]
        if (detailSelected !== undefined)
            return detailSelected.totalStr
        return '';
    }
    const GetCurreDetail = () => vidaCR.plan === "610" ? "Dolares" : "Colones"
    const GetPlanSelected = () => `Plan ${vidaCR.planSelected}`
    const GetFrecuencyDetail = () => vidaCR.catQuotas.find(x => x.value === vidaCR.nQuotas)?.text ?? ""
    const GetDate = (type: string) => {
        let date = new Date();
        if (type === 'F') {
            date.setFullYear(date.getFullYear() + 1);           
            date.setDate(date.getDate() - 1);
        }
        return date.toLocaleDateString('es-ES');      
    }

    const payment = (e: any) => {
        e.preventDefault();
        vidaCR.paymentPV(vidaCR);
    }

    return (<>
        <div className='lbl-input-vida-cr'>
            <div style={rowStyle} >
                <label>Asegurado</label>
                <label>{GetFullName()}</label>
            </div>
            <div style={rowStyle} >
                <label className='mr-10'>Beneficiarios</label>
                <label>{GetBeneficiary()}</label>
            </div>
            <div style={rowStyle} >
                <label>Plan contratado</label>
                <label>{GetPlanSelected()}</label>
            </div>
            <div style={rowStyle} >
                <label>Moneda</label>
                <label>{GetCurreDetail()}</label>
            </div>
            <div style={rowStyle} >
                <label>Incluye cobertura Gastos funerarios</label>
                <label>Si</label>
            </div>
            <div style={rowStyle} >
                <label>Incluye Cobertura de Asistencia de Salud</label>
                <label>Si</label>
            </div>
            <div>
                <label ><strong> Suma Asegurada</strong></label>
            </div>
            <div style={rowStyle} >
                <label>Cobertura Muerte</label>
                <label>{GetSum(517)}</label>
            </div>
            <div style={rowStyle} >
                <label>Gastos Funerarios</label>
                <label>{GetSum(518)}</label>
            </div>
            <div style={rowStyle} >
                <label>Incluye Cobertura de Asistencia de Salud</label>
                <label>Si</label>
            </div>
            <div style={rowStyle} >
                <label>Vigencia desde</label>
                <label>{GetDate('')}</label>
            </div>
            <div style={rowStyle} >
                <label>Vigencia hasta</label>
                <label>{GetDate('F')}</label>
            </div>
            <div style={rowStyle} >
                <label>Prima con IVA</label>
                <label>{GetPrima()}</label>
            </div>
            <div style={rowStyle} >
                <label>Frecuencia de pago</label>
                <label>{GetFrecuencyDetail()}</label>
            </div>
        </div>
        <div className='mt-30 mb-20 lbl-input-vida-cr' >
            <label style={{ fontSize: '20px' }}><strong>Realizar pago de la póliza </strong></label>
        </div>

        <div style={{ background: '#E1E1E1', padding: '20px 30px 30px 20px' }}>
            <Input
                field='feePay'
                id='feePay'
                label='Monto a pagar'
                onChange={() => { }}
                value={vidaCR.feePay}
                type='CURRENCY_FORMAT'
                isReadOnly={true}
            />
            <Input
                id='cardName'
                field='cardName'
                label='Nombre del tarjetahabitante'
                onChange={changeHandler}
                value={vidaCR.cardName}
            />


            <InputCard
                id='cardNumber'
                field='cardNumber'
                label='Número de  tarjeta'
                onChange={OnChageString}
                value={vidaCR.cardNumber}
                useIcon
                Icon={IconVisaMastercard}
                type='mask'
                placeholder='0000-0000-0000-0000'
            />
            <Input
                id='cardExpirationDate'
                field='cardExpirationDate'
                label='Expiración'
                onChange={changeHandler}
                value={vidaCR.cardExpirationDate}
                type='mask'
                mask='99/99'
                title='Fecha invalida'
                placeholder='MM/YY'
            />

            {isAmex && <Input
                type="mask"
                id='cardCVV'
                field='cardCVV'
                label='CVV'
                onChange={changeHandler}
                value={vidaCR.cardCVV}
                placeholder="0000"
                mask='9999'
                title='Código inválido'
                pattern="\d\d\d\d"
            />}
            {!isAmex && <Input
                type="mask"
                id='cardCVV'
                field='cardCVV'
                label='CVV'
                onChange={changeHandler}
                value={vidaCR.cardCVV}
                placeholder="000"
                mask='999'
                title='Código inválido'
                pattern="\d\d\d"
            />}
            <div className='mt-30' style={{ display: 'flex', justifyContent: 'center' }}>
                <button className='btn-vida-cr next' onClick={payment}>
                    ¡Pagar ahora!
                </button>
            </div>

        </div>
        <div className='mb-20'>
            <CheckBox
                field='acceptTermsPV'
                label='Acepto términos y condiciones de uso'
                onChange={changeHandler2}
                onClickLabel={() => setModalTerm(true)}
                value={vidaCR.acceptTermsPV}

            />
        </div>
        <Modal isOpen={modalTerm} style={styleModal} className='modal modal-content' preventScroll={true}>
            <div className="mt20 mb-20" style={{ textAlign: 'justify', color: '#4D4D4D', paddingLeft: '10%', paddingRight: '10%', paddingTop: '20px', paddingBottom: '20px', fontSize: '15px' }} >
                <p style={{ color: '#008866' }} ><strong>Terminos y Condiciones </strong> </p>
                <p>Para su seguridad <strong>Seguros LAFISE</strong> no guardará registros relacionados con la información de la tarjeta de crédito proporcionada en esta pantalla. </p>
                <p>El número de tarjeta se utilizará únicamente para ser procesada por el monto descrito. Una vez que el cliente acepte pagar la prima, <strong>Seguros LAFISE</strong> utilizará un verificador de transacciones de gestión de cobros.</p>
                <p>El cliente es responsable por la veracidad de la información de la tarjeta ingresada para realizar el pago.<strong> Seguros LAFISE </strong>no asume responsabilidad alguna ante el titular de la tarjeta por el pago a realizar con aceptación de los presentes términos y condiciones.</p>
                <p><span style={{ color: '#008866' }}>Derechos de autor:</span> Cualquier réplica en otro servidor de nuestra base de datos o cualquier material contenido en el sitio de Seguros LAFISE, puede constituir una violación de las leyes de derecho de autor, de las leyes de marcas comerciales, de las leyes de privación y publicidad y de las leyes y reglamentos de comunicaciones. </p>
                <p><span style={{ color: '#008866' }}>Cancelaciones y devoluciones:</span> Toda cancelación solicitada por el cliente debe remitirse a través de los medios autorizados por Seguros LAFISE. Las primas pagadas y no devengadas* serán devueltas al cliente siempre y cuando no presente mora en otras pólizas con la compañía, en cuyo caso se procederá a la aplicación del monto a favor con previa autorización de cliente.</p>
                <p>*Prima No Devengada: es la que usted tiene derecho a recuperar cuando por algún motivo cancela su seguro antes de tiempo.</p>
            </div>
            <div className="modal-footer">
                <button className="modal-btn-close" style={{ background: '#008866' }} onClick={() => setModalTerm(false)}>Cerrar</button>
            </div>
        </Modal>
    </>
    );
}

export { StepPurchaseSummary }